import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=21b6fa17&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=21b6fa17&lang=less&scoped=true&"
import style1 from "./Editor.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6fa17",
  null
  
)

component.options.__file = "Editor.vue"
export default component.exports